export default __webpack_public_path__ + "static/12-5bca9c40cc5dee842ce03c18611ab373.webp";